<script setup lang="ts">
import { computed } from "vue";

import { navigationActions } from "@/action/navigationActions";
import LinkedItems from "@/components/link/LinkedItems.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { LinkingCard } from "@/model/link";
import { useCardStore } from "@/store/card";

import AttributeChip from "./AttributeChip.vue";

const props = defineProps<{ linkingCard: LinkingCard; showUpperLevelLinks?: boolean }>();

const linksCount = computed(() => {
  const card = useCardStore().cards[props.linkingCard.id];
  if (!card) return 0;
  return card.objectives.length + card.linkedStickies.length;
});

const handleAddLinks = () => {
  return navigationActions.openModal("attribute-chip", "LinkModal", {
    attrs: {
      targets: [props.linkingCard],
      setReturnFocus: "#sticky-links-chip-trigger-" + props.linkingCard.id,
    },
  });
};
</script>

<template>
  <AttributeChip
    :id="'sticky-links-chip-trigger-' + linkingCard.id"
    name="links-chip"
    :dropdown-props="{ width: linksCount ? 'xlg' : 'md', maxHeight: 'lg' }"
    text-placeholder="0"
    :text="linksCount ? linksCount.toString() : undefined"
    :tooltip="$t('general.links')"
    highlight-on-change
  >
    <template #icon>
      <SvgIcon name="general/link" />
    </template>
    <LinkedItems
      :linking-target="linkingCard"
      :show-upper-level-links="showUpperLevelLinks"
      @add="handleAddLinks"
    />
  </AttributeChip>
</template>
